export class InvoiceReceiver{
    constructor(
        public name: string,
        public isEuropean: boolean,
        public vatNumber: string,
        public city: string,
        public postCode: string,
        public street: string,
        public option?: string | null,
        public id?: number | null
    ){}
}